@if (displayError) {
  <mat-error class="my-2">
    {{errorMsg | translate: errorMsgOptions}}
  </mat-error>
}
